import { queryOptions, useQuery, type QueryClient } from '@tanstack/react-query';
import { dados, type ClienteDaApi } from '@/lib/api/cliente';
import { useApi } from '@/lib/servicos';
import type { Me } from '../sessao';

export const meChaves = {
  me: ['me'] as const,
};

/** `GET /api/v1/me`: a consulta raiz do painel (docs/02). */
export function consultaDoMe(api: ClienteDaApi) {
  return queryOptions({
    queryKey: meChaves.me,
    queryFn: ({ signal }) => dados(api.GET('/api/v1/me', { signal })),
    staleTime: 60_000,
  });
}

export function useMe() {
  return useQuery(consultaDoMe(useApi()));
}

/** Busca o `/me` de novo, sem cache (logo depois de entrar). */
export async function carregarMe(queryClient: QueryClient, api: ClienteDaApi): Promise<Me> {
  queryClient.removeQueries({ queryKey: meChaves.me });
  return queryClient.query(consultaDoMe(api));
}
